import './metric.css';

type Props = {
  label: string;
  children: React.ReactNode;
};

const Metric = ({ label, children }: Props) => {
  return (
    <div className="metric">
      <div className="label">{label}</div>
      <div className="value">{children}</div>
    </div>
  );
};

export default Metric;
